var map = {
	"./backspace.svg": 2742,
	"./close.svg": 1691,
	"./eng_close.svg": 6002,
	"./eng_go_back.svg": 4510,
	"./go_back.svg": 1507,
	"./lang_switch.svg": 2848,
	"./shift.svg": 2563,
	"./space.svg": 4213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2225;